import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ClockCircleOutline, PaperClipOutline } from '@ant-design/icons-angular/icons';

import { RichTextEditorComponent } from './rich-text-editor/rich-text-editor.component';
import { NotificationDetailModalComponent } from './notification-detail-modal/notification-detail-modal.component';
import { NotificationPreviewPipe } from './pipes/notification-preview.pipe';

@NgModule({
  declarations: [
    RichTextEditorComponent,
    NotificationDetailModalComponent,
    NotificationPreviewPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    QuillModule.forRoot(),
    NzModalModule,
    NzButtonModule,
    NzIconModule.forChild([ClockCircleOutline, PaperClipOutline]),
  ],
  exports: [
    RichTextEditorComponent,
    NotificationDetailModalComponent,
    NotificationPreviewPipe,
  ],
})
export class NotificationUiModule {}
